import type { Moment } from "moment";

export default async function fetchLegacyExport(
  startDate: Moment | null | undefined,
  run: (
    periodStart: Moment,
    onSuccess: (response: { data: string }) => void,
    onError: (error: unknown) => void,
  ) => void,
): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!startDate) {
      reject(new Error("Missing period start"));
      return;
    }

    run(startDate, (response) => resolve(response.data), reject);
  });
}
